// extracted by mini-css-extract-plugin
module.exports = {"sidebarData":"Sidebar_sidebarData__qxhAB","sidebarDescription":"Sidebar_sidebarDescription__1RRMw","sidebarLabel":"Sidebar_sidebarLabel__2sKSG"};